import { AlgoliaFilterValue, AlgoliaFilterValueType } from '../../lib/algolia'
import { IMarketplaceProductsFilter } from '../../graphql/queries/marketplace-products-search'
import { SortOption } from '../../components/sort-options'

export interface IUseMarketplaceProductsSearchOptions {
  query?: string
  filters?: {
    attribute: string
    values: AlgoliaFilterValue[]
  }[]
  itemsPerPage?: number
  page?: number
  sort?: SortOption
  skip?: boolean
}

function wrapWithAND(
  filters: IMarketplaceProductsFilter[]
): IMarketplaceProductsFilter | undefined {
  if (filters.length == 0) {
    return undefined
  }
  if (filters.length == 1) {
    return filters[0]
  }
  return {
    AND: filters,
  }
}

function wrapWithOR(
  filters: IMarketplaceProductsFilter[]
): IMarketplaceProductsFilter[] {
  if (filters.length == 0) {
    return []
  }
  if (filters.length == 1) {
    return filters
  }
  return [
    {
      OR: filters,
    },
  ]
}

function transformMatchFilterValue(
  attribute: string,
  value: string
): IMarketplaceProductsFilter[] {
  return [
    {
      string: {
        attribute,
        match: value,
      },
    },
  ]
}

function transformNumericRangeFilterValue(
  attribute: string,
  value: {
    min?: number
    max?: number
  }
): IMarketplaceProductsFilter[] {
  if (value.min === undefined && value.max === undefined) {
    return []
  }
  return [
    {
      numeric: {
        attribute,
        gte: value.min,
        lte: value.max,
      },
    },
  ]
}

export function transformProductFilters(
  filters: IUseMarketplaceProductsSearchOptions['filters']
): IMarketplaceProductsFilter | undefined {
  if (!filters) {
    return undefined
  }

  return wrapWithAND(
    filters.flatMap(({ attribute, values }) => {
      return wrapWithOR(
        values.flatMap(value => {
          switch (value.type) {
            case AlgoliaFilterValueType.MATCH:
              return transformMatchFilterValue(attribute, value.value)
            case AlgoliaFilterValueType.NUMERIC_RANGE: {
              return transformNumericRangeFilterValue(attribute, value.value)
            }
          }
        })
      )
    })
  )
}

export default transformProductFilters
